import { useState } from "react";

import cookieImg from "../assets/bigflex.jpg"; // replace with your image

const FeaturedRecipe = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="bg-[#fff9e6] py-20">
      <div className="max-w-5xl mx-auto px-6">
        
        <div className="bg-[#8f4a3c] rounded-3xl overflow-hidden grid grid-cols-1 md:grid-cols-2">
          
          {/* LEFT IMAGE */}
          <div className="h-full">
            <img
              src={cookieImg}
              alt="Single Serve Chocolate Chip Cookie"
              className="w-full h-full object-cover"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="p-12 flex flex-col justify-center text-white">
            
            <span className="uppercase tracking-wide text-yellow-300 text-sm mb-4">
              your favourite of the month
            </span>

            <h2 className="text-4xl md:text-5xl font-serif mb-6 leading-tight">
              Single Serve Chocolate Chip Cookie
            </h2>

            <p className="text-lg leading-relaxed mb-4">
              No Oven, No Microwave, No Airfryer. This{" "}
              <span className="font-semibold">single serve chocolate chip cookie</span>{" "}
              is crispy on the outside, so soft and chewy on the inside
              {!expanded && "..."}
            </p>

            {expanded && (
              <p className="text-lg leading-relaxed mb-4">
                and it is just so so good ♡ Made with simple pantry ingredients
                and perfect when you’re craving something sweet without the
                effort of baking a full batch.
              </p>
            )}

            {/* READ MORE */}
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-yellow-300 font-medium underline w-fit mb-8"
            >
              {expanded ? "Read less" : "Read more"}
            </button>

            
            {/* <Link
              to="/recipes"
              className="bg-yellow-400 text-[#5a2a1f] px-8 py-4 rounded-full w-fit text-lg font-medium hover:bg-yellow-300 transition"
            >
              view recipe
            </Link> */}

          </div>
        </div>

      </div>
    </section>
  );
};

export default FeaturedRecipe;
